<p-blockUI [blocked]="blocked">
  <div id="center" class="blocked-div">
    <p-progressSpinner class="blocked-div-spinner" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>

<div class="container-fluid remove-z-index mt-0">
  <p-confirmDialog class="confirm-message" appendTo="body"></p-confirmDialog>
  <p-confirmDialog key="warning" appendTo="body"></p-confirmDialog>
  <div class="row">
    <div class="col-12 flex p-0">
      <div class="col-3">
        <div class="row m-0 p-0">
          <div class="col-11 multi-select-div">
            <div class="ui-inputgroup mb-0 filter-label">
              <button pButton class="theme-button noHover label-button" type="button" label="Filter"></button>
              <p-multiSelect [options]="filterOptions" (onChange)="onApplyFilter()" [(ngModel)]="selectedStatuses" optionLabel="label" optionValue="value"
                [filter]="true" filterBy="label" id="multi-select-statuses" placeholder="Sel. Status" [maxSelectedLabels]="1"
                styleClass="multi-selection-dropdown">
                <ng-template let-item pTemplate="selectedItem">
                  <span class="align-middle">{{item.label}}</span>
                </ng-template>
                <ng-template let-status pTemplate="item">
                  {{status.label}}
                </ng-template>
              </p-multiSelect>
            </div>
          </div>

          <div class="col-1 refresh-batches-div">
            <button pButton class="refresh-batches" icon="fa fa-refresh" (click)="onApplyFilter()"></button>
          </div>
        </div>
        <div class="row m-0 p-0">
          <div class="col-11 padding-top-filter-options multi-select-div">
            <div class="ui-inputgroup mb-0 filter-label">
              <button pButton class="theme-button noHover label-button" type="button" label="Protocol"></button>
              <p-multiSelect [options]="processFlowsList" name="processFlowsList" (onChange)="onApplyFilter()"
                [(ngModel)]="selectedProcessFlowList" optionLabel="label" optionValue="value" [filter]="true" filterBy="label" id="multi-select-statuses"
                placeholder="Sel. Protocol" [maxSelectedLabels]="1" styleClass="multi-selection-dropdown">
                <ng-template let-item pTemplate="selectedItem">
                  <span class="align-middle">{{item.label}}</span>
                </ng-template>
                <ng-template let-status pTemplate="item">
                  {{status.label}}
                </ng-template>
              </p-multiSelect>
            </div>
          </div>

          <div class="col-1 padding-top-filter-options refresh-batches-div">
            <button pButton class="refresh-batches reset-button" icon="pi pi-times" (click)="resetAllFilter()"></button>
          </div>
        </div>
        <div class="row m-0 p-0">
          <div class="col-11 padding-top-filter-options multi-select-div">
            <div class="ui-inputgroup" id="date-picker">
              <button pButton class="theme-button noHover label-button" type="button" label="Date"></button>
              <p-calendar [(ngModel)]="fromDate" readonlyInput="true" (onSelect)="onApplyFilter()"
                dateFormat="dd.mm.yy" [showIcon]="true" placeholder="Sel. Start Date" showButtonBar="true"
                (onClearClick)="onApplyFilter()" (onTodayClick)="onApplyFilter()">
              </p-calendar>
            </div>
          </div>
          <div class="col-1 padding-top-filter-options"></div>
          <div class="flex justify-content-between px-0">
            <span class="m-0 col-7 px-0">Number Of Plates Matching Filter:
              <span class="m-0 font-weight-bold text-success" style="font-size: 1.2rem;">{{plates == null ? 0: plates.length}}</span>
            </span>
            <span class="col-4 m-0 px-0">Show Due Date <p-inputSwitch [(ngModel)]="showDueDate"></p-inputSwitch></span>
          </div>
        </div>

      </div>
      <div class="col-9">
        <div class="col-12 flex" id="topGroup">

          <div class="col-4 topDivspacing pr-0" id="topDiv">
            <div class="ui-inputgroup input-class">
              <button pButton class="theme-button noHover label-button" type="button" label="User ID"></button>
              <input pInputText name="UserPUID" [(ngModel)]="puid" size="10" id="puid-field"/>
            </div>
            <div class="ui-inputgroup input-class">
              <button pButton class="theme-button noHover label-button" type="button" label="ArrayID"></button>
              <input pInputText name="SearchPlate" [(ngModel)]="plateToSearch" size="10" (keydown.enter)="searchForPlate()"/>
              <button pButton class="search-field-blue-end" icon="fa fa-search" (click)="searchForPlate()"></button>
            </div>
            <div class="ui-inputgroup input-class">
              <button pButton class="theme-button noHover label-button" type="button" label="Sample ID"></button>
              <input pInputText name="SearchSample" [(ngModel)]="sampleToSearch" size="10" (keydown.enter)="searchForSample()"/>
              <button pButton class="search-field-blue-end" icon="fa fa-search" (click)="searchForSample()"></button>
            </div>
          </div>

          <div class="col-5 topDivspacing pl-0 pr-0 align-left">
            <div class="col-12 headers">
              <h5>
                Plate: <strong>{{selectedPlate?.lastUpdatedPlateID}} </strong>
              </h5>
            </div>
            <div class="col-12 headers statusField headerNonTop">
              <h5>
                Status: <strong> {{selectedPlate?.status}} </strong>
              </h5>
            </div>
            <div class="col-12 headers headerNonTop">
              <h5>
                Sender:<strong> {{selectedPlate?.sender}}</strong>
              </h5>
            </div>
            <div class="col-12 headers">
              <h5>
                Sample-Type: <strong> {{selectedPlate?.sampleType}} </strong>
              </h5>
            </div>
          </div>

          <div class="col-3 topDivspacing p-0">
            <div class="col-12 p-0">
              <p-fileUpload #fileUploaderRedoSamples styleClass="file-upload" (onSelect)="onRedoFileSelect($event)" (uploadHandler)="uploadSingleRedoFile($event)" mode="basic"
                customUpload="true" accept=".csv" chooseLabel="Upload Sample Redo File" auto="true"></p-fileUpload>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 flex p-0">
      <div class="col-3">
        <div class="tableLHS1">
          <p-table [value]="plates" selectionMode="single" [(selection)]="tableSelectedRow" (onRowSelect)="fetchPlate($event)"
            (onRowUnselect)="removePlateSelection()" name="allPlates" ngDefaultControl [loading]="loading">
            <ng-template pTemplate="header">
              <tr>
                <th scope="col" class="batch">Plate ID<span *ngIf="showDueDate"><br/> (Due Date) </span></th>
                <th scope="col" class="status">Status</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-plate>
              <tr [pSelectableRow]="plate">
                <td style="width: 30%;" [ngClass]="getPriorityClass(plate?.priority)" class="text-break pr-0">
                  {{plate?.lastUpdatedPlateID}}
                  <i class="fa fa-solid fa-star" *ngIf="plate?.reRun"></i>
                  <i class="fa-solid fa-arrow-right-arrow-left" *ngIf="checkStatusChange(plate)"></i>
                  <span *ngIf="showDueDate"><br/> ({{ convertTimeStampToDate(plate.dueDate) | date : 'dd.MM.yyyy' }}) </span>
                </td>
                <td style="width: 75%;" [ngClass]="getPriorityClass(plate?.priority)" class="text-break pr-0">
                  {{plate?.status}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <div class="col-12 mt-2" *ngIf="selectedPlate?.plateID">
          <div class="col-6" *ngFor="let plate of selectedPlate?.sourcePlates; let i = index;">
            <button pButton icon="fa fa-comment" label="{{plate.plateID}}" (click)="showComments(plate.plateID)"
              class="buttonsRoundResponsive"></button>
          </div>
        </div>
      </div>
      <div class="col-9">
        <div legend="Array View" toggleable="true" class="col-12 main-content-div">
          <div class="col-12 d-flex flex-row legendBorderWithPadding parentDiv">
            <div class="col-9 m-0 p-1 legendHeader font-weight-bold">
              Legend
            </div>
            <div class="col-3 m-0 p-1 legendHeader font-weight-bold">
              Array Output
            </div>
          </div>
          <div class="col-12 p-0 col-12 d-flex flex-row legendBorderWithPadding parentDiv" >
            <div class="col-9 flex legendBorder384">
              <div class="col-4 p-0 m-0">
                <div class="d-flex flex-row justify-content-center p-0 m-0">
                  <button class="d-inline-flex justify-content-center m-0" [ngClass]="getButtonColor('callRate')" (click)="updateSelectedValueForComparision('callRate')">Call Rate</button>
                </div>
                <div class="d-flex flex-row justify-content-center p-0 m-0">
                  <span>Color Above the CutOff</span>
                </div>
                <div class="d-flex flex-row justify-content-center p-0 m-0">
                  <svg height="30" width="40" viewBox="0 0 40 40">
                    <circle cx="18" cy="18" r="15" stroke="#000000" stroke-width="1" [attr.fill]="getLegendColor('callRate', 'pass')" />
                  </svg>
                  <input placeholder="CutOff 1" [(ngModel)]="callRateCutoff1" class="cutoff-input-width"/>
                </div>
                <div class="d-flex flex-row justify-content-center p-0 m-0">
                  <svg height="30" width="40" viewBox="0 0 40 40">
                    <circle cx="18" cy="18" r="15" stroke="#000000" stroke-width="1" [attr.fill]="getLegendColor('callRate', 'check')" />
                  </svg>
                  <input placeholder="CutOff 2" [(ngModel)]="callRateCutoff2" class="cutoff-input-width"/>
                </div>
                <div class="d-flex flex-row justify-content-center p-0 m-0">
                  <svg height="30" width="40" viewBox="0 0 40 40">
                    <circle cx="18" cy="18" r="15" stroke="#000000" stroke-width="1" [attr.fill]="getLegendColor('callRate', 'fail')" />
                  </svg>
                  <input placeholder="CutOff 3" [(ngModel)]="callRateCutoff3" class="cutoff-input-width"/>
                </div>
              </div>
              <div class="col-4 p-0 m-0">
                <div class="d-flex flex-row justify-content-center p-0 m-0">
                  <button class="d-inline-flex justify-content-center m-0" [ngClass]="getButtonColor('qcCallRate')" (click)="updateSelectedValueForComparision('qcCallRate')">QC Call Rate</button>
                </div>
                <div class="d-flex flex-row justify-content-center p-0 m-0">
                  <span>Color Above the CutOff</span>
                </div>
                <div class="d-flex flex-row justify-content-center p-0 m-0">
                  <svg height="30" width="40" viewBox="0 0 40 40">
                    <circle cx="18" cy="18" r="15" stroke="#000000" stroke-width="1" [attr.fill]="getLegendColor('qcCallRate', 'pass')" />
                  </svg>
                  <input placeholder="CutOff 1" [(ngModel)]="qcCallRateCutoff1" class="cutoff-input-width"/>
                </div>
                <div class="d-flex flex-row justify-content-center p-0 m-0">
                  <svg height="30" width="40" viewBox="0 0 40 40">
                    <circle cx="18" cy="18" r="15" stroke="#000000" stroke-width="1" [attr.fill]="getLegendColor('qcCallRate', 'check')" />
                  </svg>
                  <input placeholder="CutOff 2" [(ngModel)]="qcCallRateCutoff2" class="cutoff-input-width"/>
                </div>
                <div class="d-flex flex-row justify-content-center p-0 m-0">
                  <svg height="30" width="40" viewBox="0 0 40 40">
                    <circle cx="18" cy="18" r="15" stroke="#000000" stroke-width="1" [attr.fill]="getLegendColor('qcCallRate', 'fail')" />
                  </svg>
                  <input placeholder="CutOff 3" [(ngModel)]="qcCallRateCutoff3" class="cutoff-input-width"/>
                </div>
              </div>
              <div class="col-4 p-0 m-0">
                <div class="d-flex flex-row justify-content-center p-0 m-0">
                  <button class="d-inline-flex justify-content-center m-0" [ngClass]="getButtonColor('dqc')" (click)="updateSelectedValueForComparision('dqc')">DQC</button>
                </div>
                <div class="d-flex flex-row justify-content-center p-0 m-0">
                  <span>Color Above the CutOff</span>
                </div>
                <div class="d-flex flex-row justify-content-center p-0 m-0">
                  <svg height="30" width="40" viewBox="0 0 40 40">
                    <circle cx="18" cy="18" r="15" stroke="#000000" stroke-width="1" [attr.fill]="getLegendColor('dqc', 'pass')" />
                  </svg>
                  <input placeholder="CutOff 1" [(ngModel)]="dqcCutoff1" class="cutoff-input-width"/>
                </div>
                <div class="d-flex flex-row justify-content-center p-0 m-0">
                  <svg height="30" width="40" viewBox="0 0 40 40">
                    <circle cx="18" cy="18" r="15" stroke="#000000" stroke-width="1" [attr.fill]="getLegendColor('dqc', 'check')" />
                  </svg>
                  <input placeholder="CutOff 2" [(ngModel)]="dqcCutoff2" class="cutoff-input-width"/>
                </div>
                <div class="d-flex flex-row justify-content-center p-0 m-0">
                  <svg height="30" width="40" viewBox="0 0 40 40">
                    <circle cx="18" cy="18" r="15" stroke="#000000" stroke-width="1" [attr.fill]="getLegendColor('dqc', 'fail')" />
                  </svg>
                  <input placeholder="CutOff 3" [(ngModel)]="dqcCutoff3" class="cutoff-input-width"/>
                </div>
              </div>
            </div>
            <div class="col-3 legendBorder384">
              <div class="row m-0 p-0 d-flex flex-column">
                <div class="col-12">
                  <input pInputText class="w-100 form-control" name="profile" type="file"
                    accept=".csv" (change)="onFileSelect($event)" id="fileChooser" placeholder="Upload File"
                    #arrayOutputFile />
                </div>
                <div class="col-12 d-flex flex-row justify-content-center p-0">
                  <button pButton icon="fa fa-upload" type="submit" (click)="uploadArrayOutputFile(arrayOutputFile)"
                    [disabled]="isFileNotSelected" class="buttons-round uploadButton" label="Upload">
                  </button>
                </div>
                <div class="col-12">
                  <div class="ui-inputgroup">
                    <input style="width: 11rem;" type="text" pInputText placeholder="Reporting File name" [(ngModel)]="reportingFileName"/>
                    <button type="button" label="Save" [disabled]="disableSaveFileName()" (click)="updateReportingFileName()" pButton class="saveButton"></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 p-0 col-12 d-flex flex-row justify-content-around legendBorderWithPadding parentDiv" name="sample-legend-div">
              <div class="d-flex flex-row justify-content-start p-0 m-1">
                <svg height="30" width="40" viewBox="0 0 40 30" class="m-1">
                  <rect width="27" x="11.5" y="1.5" height="27" stroke="#3f48cc" stroke-width="4" fill="#ffffff"/>
                  <circle cx="25" cy="15" r="9" stroke="#c3c3c3" stroke-width="1" fill="#c3c3c3" />
                  <line x1="11.5" y1="1.5" x2="38.5" y2="28.5" stroke="#555555" stroke-width="4" />
                  <line x1="11.5" y1="28.5" x2="38.5" y2="1.5" stroke="#555555" stroke-width="4" />
                </svg>
                <span class="m-2">Gender Comparison Failed</span>
              </div>
              <div class="d-flex flex-row justify-content-start p-0 m-1">
                <svg height="30" width="40" viewBox="0 0 40 30" class="m-1">
                  <rect width="27" x="11.5" y="1.5" height="27" stroke="#3f48cc" stroke-width="4" fill="#ffffff"/>
                  <circle cx="25" cy="15" r="9" stroke="#c3c3c3" stroke-width="1" fill="#c3c3c3" />
                  <line x1="11.5" y1="1.5" x2="38.5" y2="28.5" stroke="#ed1c24" stroke-width="4" />
                  <line x1="11.5" y1="28.5" x2="38.5" y2="1.5" stroke="#ed1c24" stroke-width="4" />
                </svg>
                <span class="m-2">Sample Not Present</span>
              </div>
              <div class="d-flex flex-row justify-content-start p-0 m-1">
                <svg height="30" width="40" viewBox="0 0 40 30" class="m-1">
                  <rect width="27" x="11.5" y="1.5" height="27" stroke="#3f48cc" stroke-width="4" fill="#f06292"/>
                  <circle cx="25" cy="15" r="9" stroke="#c3c3c3" stroke-width="1" fill="#c3c3c3" />
                </svg>
                <span class="m-2">Auto ReRun On</span>
              </div>
              <div class="d-flex flex-row justify-content-start p-0 m-1">
                <svg height="30" width="40" viewBox="0 0 40 30" class="m-1">
                  <rect width="27" x="11.5" y="1.5" height="27" stroke="#3f48cc" stroke-width="4" fill="#ffffff" />
                  <circle cx="25" cy="15" r="9" stroke="#c3c3c3" stroke-width="1" fill="#c3c3c3" />
                  <polygon points="1.5,0 8.5,15 1.5,28.5" />
                </svg>
                <span class="m-2">Redo Samples</span>
              </div>
          </div>
          <div class="col-12 p-0 col-12 d-flex flex-row legendBorderWithPadding parentDiv" *ngIf="selectedPlate?.plateID">
            <div class="col-8 m-0 p-0 d-flex flex-row justify-content-start">
              <div *ngFor="let plate of selectedPlate?.sourcePlates; let i = index;" [ngClass]="getPlateBorderClass(i)" class="m-1 text-break" [pTooltip]="getPlateSampleTypes(i)">
                <span>{{plate.lastUpdatedPlateID || plate.plateID}}</span>
                <p-dropdown #redoSelector placeholder="Select Redo" [options]="getPlateRedoList(plate.processFlowName, i)" [style]="{'width':'9.5vw'}" (onChange)="updatePlateRedoValue($event,i)"
                  name="redoList" [(ngModel)]="selectedRedoTypes[i]">
                </p-dropdown>
              </div>
            </div>
            <div class="col-4 m-0 ml-1 mt-2 mb-2 d-flex flex-row justify-content-around">
              <button *ngIf="!isSampleSelectionMode" pButton label="Sample Redo" [disabled]="disableCompleteAnalysisButton()" (click)="startSampleSelectionForRedo()" class="buttons-round green-button" >
              </button>
              <button *ngIf="!isSampleSelectionMode" pButton label="Complete Analysis" [disabled]="disableCompleteAnalysisButton()" (click)="toggleCompleteAnalysisConfirmationPopUp()" class="buttons-round" >
              </button>
              <button *ngIf="isSampleSelectionMode" pButton label="Start Redo" [disabled]="disableStartSampleRedoButton()" (click)="startSampleRedo()" class="buttons-round orange-button" >
              </button>
              <button *ngIf="isSampleSelectionMode" pButton label="Exit Redo" [disabled]="disableCompleteAnalysisButton()" (click)="exitSampleRedo()" class="buttons-round red-button" >
              </button>
            </div>
          </div>
          <div class="col-12 pl-0" *ngIf="selectedPlate?.plateID">
            <div class="col-12 p-0 w-100" style="padding-top: 1%" >
              <table data-vertable="ver5" aria-describedby="Detail view" id="scanTable" class="table w-100">
                <thead>
                  <tr class="row100 head">
                    <th scope="col" class="column100 column1" style="padding: 0.75rem 0px 0.75rem 0px!important; width: 20px;"></th>
                    <th scope="col" class="column100 column2" style="padding: 0.75rem 0px 0.75rem 0px!important;" *ngFor="let col of headers.columnHeaders384">{{col}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="row100" *ngFor="let row of headers.rowHeaders384; let i = index;">
                    <td class="column100 column1" style="color: #006b96;font-weight: bold; padding-right:0px!important; padding-top:0.5%; padding-bottom:0.5%;">{{row}}</td>
                    <td class="column100 column2 p-0" *ngFor="let col of headers.columnHeaders384; let j = index">
                      <button class="grid-sample-button" (click)="clickSample(row, col)">
                        <svg *ngIf="!isSampleSelected(row, col)" viewBox="0 0 40 30" class="sample-svg">
                          <rect width="27" x="11.5" y="1.5" height="27" [attr.stroke]="getQuadrant(i, j)" stroke-width="3" [attr.fill]="isAutoReRun(row, col)" />
                          <circle cx="25" cy="15" r="9" attr.stroke="{{circleBorder}}" stroke-width="2" attr.fill="{{getSampleCircleFillColor(row, col)}}" />
                          <line *ngIf="isCrossRequired(row, col)" x1="11.5" y1="1.5" x2="38.5" y2="28.5" attr.stroke="{{getCrossColor(row, col)}}" stroke-width="3" />
                          <line *ngIf="isCrossRequired(row, col)" x1="11.5" y1="28.5" x2="38.5" y2="1.5" attr.stroke="{{getCrossColor(row, col)}}" stroke-width="3" />
                          <polygon *ngIf="isRedoSample(row, col)" points="1.5,0 8.5,15 1.5,28.5" />
                        </svg>
                        <svg *ngIf="isSampleSelected(row, col)" viewBox="0 0 40 30" class="sample-svg">
                          <rect width="27" x="11.5" y="1.5" height="27" fill="#f06292" />
                          <polygon *ngIf="isRedoSample(row, col)" points="1.5,0 8.5,15 1.5,28.5" />
                        </svg>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Sample Information" [(visible)]="samplePopUpVisible" [modal]="true" [contentStyle]="{'max-height':'80vh', 'width':'40vw', 'overflow-y':'auto'}" [resizable]="false" [blockScroll]="true" position="top">
  <div>
    <div class="d-flex flex-column justify-content-start align-middle">
      <div class="ui-inputgroup input-class mb-2">
        <button pButton class="theme-button noHover label-button" type="button" label="Array Position"></button>
        <input pInputText type="text" name="position" [value]="selectedSample.position"  readonly />
      </div>
      <div class="ui-inputgroup input-class mb-2">
        <button pButton class="theme-button noHover label-button" type="button" label="Sample ID"></button>
        <input pInputText type="text" name="sampleID" [value]="selectedSample.sampleID" readonly />
      </div>
      <div class="ui-inputgroup input-class mb-2">
        <button pButton class="theme-button noHover label-button" type="button" label="Source Plate ID"></button>
        <input pInputText type="text" name="sourcePlateID" [value]="selectedSample.sourcePlateID" readonly />
      </div>
      <div class="ui-inputgroup input-class mb-2">
        <button pButton class="theme-button noHover label-button" type="button" label="Source Position"></button>
        <input pInputText type="text" name="sourcePlatePosition" [value]="selectedSample.sourcePlatePosition" readonly />
      </div>
      <div class="ui-inputgroup input-class mb-2">
        <button pButton class="theme-button noHover label-button" type="button" label="Sample Type"></button>
        <input pInputText type="text" name="sampleType" [value]="selectedSample.sampleType" readonly />
      </div>
      <div class="mb-2">
        <p-table [value]="[{}]" >
          <ng-template pTemplate="header">
            <tr>
              <th scope="col" colspan="2">Array Results</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data>
            <tr>
              <td>Call Rate</td>
              <td>{{selectedSample?.callRate}}</td>
            </tr>
            <tr>
              <td>QC Call Rate</td>
              <td>{{selectedSample?.qcCallRate}}</td>
            </tr>
            <tr>
              <td>Computed Gender</td>
              <td>{{selectedSample?.computedGender}}</td>
            </tr>
            <tr>
              <td>DQC</td>
              <td>{{selectedSample?.dqc}}</td>
            </tr>
            <tr>
              <td>Pass/Fail</td>
              <td>{{selectedSample?.evaluationResult}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="ui-inputgroup input-class mb-2">
      <button pButton (click)="toggleCommentView()" class="theme-button adjust-width" type="button" [label]="commentView? 'Hide Comment(s)': 'View Comment(s)'"></button>
    </div>
    <div *ngIf="commentView">
      <div  class="col-12 rounded border border-secondary commentBubble">
        <div *ngFor="let comment of sampleComments">
          <div class="col-12 p-0 commentBubbleSection">
            <div style="text-align:left" class="col-12 commentPUIDDate">
              <label>{{comment.puid}} | {{comment.timeStamp | date: 'dd.MM.yy HH:mm'}}</label>
            </div>
            <div style="text-align:left" class="col-12 commentPUIDDate font-weight-bold">
              <p>{{comment.comment}}</p>
            </div>
          </div>
        </div>
      </div>
      <br>
      <div class="col-12 d-flex flex-row justify-content-start">
        <div class="col-6">
          <textarea pInputTextarea class="commentTextArea" placeholder="Add new comment here..."
            [(ngModel)]="newComment"></textarea>
        </div>
        <div class="col-3">
          <button type="button" label="Add Comment" [disabled]="disableAddComment()" (click)="addCommentToSample()" pButton class="buttons-round"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog header="Redo Confirmation" [(visible)]="sampleRedoConfirmationVisible" [modal]="true" [contentStyle]="{'max-height':'80vh', 'width':'25vw', 'overflow-y':'auto'}" [resizable]="false" [blockScroll]="true" position="top">
  <div class="row d-flex flex-row justify-content-around">
    <div class="col-12 pl-5 pr-5">
      <span class="pre-line">Samples {{selectedSample.sampleID}} on position {{selectedSample.position}} has re run count {{selectedSample.reRunCount || 0}}.
        Do you want to add the samples to redo list?
      </span>
    </div>
    <div class="col-6 d-flex flex-row justify-content-around">
      <button pButton label="Yes" icon="pi pi-check" class="buttons-round green-button" (click)="sampleRedoConfirmation()"></button>
    </div>
    <div class="col-6 d-flex flex-row justify-content-around">
      <button pButton label="No" icon="pi pi-times" class="buttons-round red-button" (click)="closeSampleRedoConfirmationPopUp()" ></button>
    </div>
  </div>
</p-dialog>

<p-dialog header="Redo Confirmation" [(visible)]="multipleSampleRedoConfirmationVisible" [modal]="true" [contentStyle]="{'width':'40vw', 'overflow-y':'auto'}" [resizable]="false" [blockScroll]="true" position="top">
  <div class="row d-flex flex-row justify-content-around">
    <div class="col-12 pl-5 pr-5">
      <span class="pre-line">Do you want to add the samples to redo list?</span>
    </div>
    <div class="col-12 pl-5 pr-5">
      <table class="table table-striped" aria-describedby="Multiple Sample Redo">
        <thead>
          <tr>
            <th>Sample ID</th>
            <th>Array ID</th>
            <th>Position</th>
            <th>ReRun Count</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let sample of multipleSampleRedoList;">
            <td>{{sample.sampleID}}</td>
            <td>{{sample.plateID}}</td>
            <td>{{sample.position}}</td>
            <td>{{sample.reRunCount}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-6 d-flex flex-row justify-content-around">
      <button pButton label="Yes" icon="pi pi-check" class="buttons-round green-button" (click)="multipleSampleRedoConfirmation()"></button>
    </div>
    <div class="col-6 d-flex flex-row justify-content-around">
      <button pButton label="No" icon="pi pi-times" class="buttons-round red-button" (click)="closeMultipleSampleRedoConfirmationPopUp()" ></button>
    </div>
  </div>
</p-dialog>

<p-dialog header="Confirmation" [(visible)]="completeAnalysisConfirmationVisible" [modal]="true" [contentStyle]="{'max-height':'80vh', 'width':'25vw', 'overflow-y':'auto'}" [resizable]="false" [blockScroll]="true">
  <div class="row d-flex flex-row justify-content-around">
    <div class="col-12" *ngIf="checkForMissingSamplesInCelFile()">
      <b><p>The following samples have no sample data: </p></b>
      <ul class="barcodeList">
        <li *ngFor="let barcode of missingBarcodesInCellFile">{{barcode}}</li>
      </ul>
      <b><p>Completing analysis will change Evaluation Result to "Completed/No Cel File"</p></b>
    </div>
    <div class="col-12">
      <span>Are you sure you want to complete analysis?</span>
    </div>
    <div class="col-6 d-flex flex-row justify-content-around">
      <button pButton label="Yes" icon="pi pi-check" class="buttons-round green-button" (click)="completeAnalysis()"></button>
    </div>
    <div class="col-6 d-flex flex-row justify-content-around">
      <button pButton label="No" icon="pi pi-times" class="buttons-round red-button" (click)="toggleCompleteAnalysisConfirmationPopUp()" ></button>
    </div>
  </div>
</p-dialog>

<p-dialog header="{{selectedPlateID + ' Comments'}}" [(visible)]="showCommentDialog" [modal]="true" position="top" [contentStyle]="{'max-height':'70vh'}">
  <app-ma-comments-popup [selectedPlateID]="selectedPlateID" [selectedPlateStatus]="selectedPlateStatus"  [plateCommentList] = "plateCommentsList" [multiPlateIdList]="selectedPlateSourcePlateIdList"  [beadChipCommentsDisplayMap]="beadChipCommentsDisplayMap" [beadChipCommentsMap]="beadChipCommentsMap" (backButtonEmitter)="hideDialog($event)" [multiPlateCommentMode]="true"></app-ma-comments-popup>
</p-dialog>

<p-dialog header="Redo Selection For Merged Plates" [(visible)]="popUpWithRedoForMergePlate" showEffect="fade"  position="top" [modal]="true" [contentStyle]="{'min-height':'25vh', 'min-width':'40vw'}">
  <div class="content-in-multi-update-popup row">
    <div class="ui-g-12" style>
      <table aria-describedby="View Plates" class="table overflow-div">
        <tr>
          <th style="border: none;"></th>
        </tr>
        <ng-container *ngFor="let mergePlate of mergeRedoSourcePlates.keys()">
          <tr>
            <td class="border-0 qc-check-table-td p-3">
              <div>
                <span style="font-weight: 700;">Merged Plate - {{mergePlate}}</span>
              </div>
            </td>
            <td class="qc-check-table-td p-3"></td>
          </tr>
          <tr *ngFor="let sourcePlate of mergeRedoSourcePlates.get(mergePlate); let i = index;">
            <td class="flex p-2 justify-content-start border-0">
              <span>PlateID - {{sourcePlate.lastUpdatedPlateID}}</span><br/>
              <span>Sample Type - {{sourcePlate.sampleType}}</span>
            </td>
            <td class="qc-check-table-td p-3">
              <p-dropdown placeholder="Select Redo" [appendTo]="mergeRedoPopUp" [options]="mergePlateSourcePlateRedoOptions.get(mergePlate)[i]" [(ngModel)]="mergePlateSourcePlateRedoSelection.get(mergePlate)[i]"></p-dropdown>
            </td>
          </tr>
        </ng-container>
      </table>
    </div>
    <div class="ui-g-12">
      <button pButton label="Set Redo" (click)="updateMultiRedoForMergedPlates()"
        class="buttons-round red-button" [disabled]="disableUpdateMultiRedoForMergedPlatesButton()">
      </button>
    </div>
  </div>
</p-dialog>
